import script from "./bcIntro.vue?vue&type=script&lang=ts&setup=true"
export * from "./bcIntro.vue?vue&type=script&lang=ts&setup=true"

import "./bcIntro.vue?vue&type=style&index=0&id=31fa7440&lang=scss&scoped=true"
import "./bcIntro.vue?vue&type=style&index=1&id=31fa7440&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31fa7440"]])

export default __exports__